import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import * as moment from 'moment';

declare const IMask;

@Directive({
  selector: '[inputMask]'
})
export class inputMaskDirective implements OnInit {
  private mask: any;
  private momentFormat = 'YYYY/MM/DD `HH:`mm';
  private _config = {
    mask: Date,
    pattern: this.momentFormat,
    overwrite: true, // defaults to `false`
    autofix: true,  // defaults to `false`, see details
    lazy: false,
    format: function (date) {
      return moment(date).format(this.momentFormat);
    },
    parse: function (str) {
      console.log('on parse:', str)
      return moment(new Date(str), this.momentFormat);
    },

  };
  @Input() inputMaskConfig: any = {};

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.init();
  }

  init() {
    const {min, max, value} = this.inputMaskConfig;
    /*if(value) {
      this._config['value'] = value;
    }*/
    if (max && min) {
      this._config['min'] = min;
      this._config['max'] = max;
      this._config['blocks'] = this.setBlockMaxAndMin(min, max);
    }
    console.log('>>>: ', this._config)
    this.mask = IMask(this.el.nativeElement, this._config);
    this.mask.value = moment(value).format(this.momentFormat);
  }

  setBlockMaxAndMin(min: Date, max: Date) {
    return {
      YYYY: {
        mask: IMask.MaskedRange,
        from: min.getFullYear(),
        to: max.getFullYear()
      },
      MM: {
        mask: IMask.MaskedRange,
        from: min.getMonth() + 1,
        to: max.getMonth() + 1
      },
      DD: {
        mask: IMask.MaskedRange,
        from: min.getDate(),
        to: max.getDate()
      },
      HH: {
        mask: IMask.MaskedRange,
        from: min.getHours(),
        to: max.getHours()
      },
      mm: {
        mask: IMask.MaskedRange,
        from: min.getMinutes(),
        to: max.getMinutes()
      }
    }
  }
  inittest() {
    var dateMask = IMask(this.el.nativeElement, {
      mask: Date,  // enable date mask

      // other options are optional
      pattern: 'Y-`m-`d `HH:`mm',  // Pattern mask with defined blocks, default is 'd{.}`m{.}`Y'
      // you can provide your own blocks definitions, default blocks for date mask are:
      blocks: {
        d: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
          maxLength: 2,
        },
        m: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2,
        },
        Y: {
          mask: IMask.MaskedRange,
          from: 1900,
          to: 9999,
        },
        HH: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 23,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
        }
      },
      // define date -> str convertion
      format: function (date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        var hour = date.getHours();
        var min = date.getMinutes();

        if (day < 10) day = "0" + day;
        if (month < 10) month = "0" + month;
        if (hour< 10) hour = "0" + hour;
        if (min< 10) min = "0" + min;


        return [year, month, day].join('-') + " " + [hour, min].join(":");
      },
      // define str -> date convertion
      parse: function (date) {
        console.log("on parse : " , str)
        var [str, time] = date.split(' ');
        var yearMonthDay = str.split('-');
        var [h, m] = time.split(':')
        return new Date(yearMonthDay[0], yearMonthDay[1] - 1, yearMonthDay[2], h, m);
      },

      // optional interval options
      min: new Date(2000, 0, 1),  // defaults to `1900-01-01`
      max: new Date(2020, 0, 1),  // defaults to `9999-01-01`

      autofix: true,  // defaults to `false`, see details

      // also Pattern options can be set
      lazy: false,

      // and other common options
      overwrite: true  // defaults to `false`
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/inputPhoneMask.ts